var React = require('react');

function IconRightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.156.133A.535.535 0 0 1 .805.09l.07.056L7 6.104.868 11.86a.533.533 0 0 1-.719.001.453.453 0 0 1-.06-.607l.06-.066 5.427-5.096L.142.806A.453.453 0 0 1 .096.198l.06-.065z","fill":"#282828","fillRule":"evenodd"}));
}

IconRightArrowInline.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12"};

module.exports = IconRightArrowInline;

IconRightArrowInline.default = IconRightArrowInline;
